import secureLocalStorage from "react-secure-storage";

import { IS_DEVICE_INFO_EXISTS, IS_USER_LOGGED_IN } from "helpers/constants";

export const Auth = (
	auth = {
		isUserLoggedIn: false,
		isDeviceInfoExists: true,
	},
	action
) => {
	switch (action.type) {
		case IS_USER_LOGGED_IN:
			const loginStatus = secureLocalStorage.getItem("currentUserStatus");

			return loginStatus ? { ...auth, isUserLoggedIn: loginStatus } : { ...auth, isUserLoggedIn: false };

		case IS_DEVICE_INFO_EXISTS:
			return { ...auth, isDeviceInfoExists: action?.payload };

		default:
			return auth;
	}
};
